
import { defineComponent, ref, reactive, nextTick } from 'vue'
import PageContent from '@/components/page-content'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/use-page-search'
import editor from '@/components/wangeditor/editor.vue'
import { publicNotice, getNotice, editNotice } from '@/service/main/system/system'
import { ElMessage } from 'element-plus'

export default defineComponent({
  name: 'notice',
  components: {
    PageContent, editor
  },
  setup() {
    const dialogVisible = ref(false)
    const loading = ref(false)
    const submitLoading = ref(false)
    const formRef = ref()
    
    const form = ref({
      noticeTitle: '',
      noticeContent: ''
    })
    
    const rules = {
      noticeTitle: [
        { required: true, message: '请输入公告标题', trigger: 'blur' },
        { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
      ],
      noticeContent: [
        { required: true, message: '请输入公告内容', trigger: 'blur' }
      ]
    }
    
    const initForm = {
      noticeTitle: '',
      noticeContent: ''
    }
    
    const noticeId = ref(0)
    const pageContentRef = ref()
    
    const addNotice = () => {
      noticeId.value = 0
      form.value.noticeTitle = initForm.noticeTitle
      form.value.noticeContent = initForm.noticeContent
      dialogVisible.value = true
      
      nextTick(() => {
        formRef.value?.resetFields()
      })
    }
    
    const changeEditor = (str: string) => {
      form.value.noticeContent = str
    }
    
    const [handleQueryClick] = usePageSearch()
    
    const getNoticeContent = (id: number) => {
      loading.value = true
      getNotice('/pc/publish/getNoticeInfo', {
        noticeId: id
      }).then(res => {
        noticeId.value = id
        form.value.noticeContent = res.data.noticeContent
        form.value.noticeTitle = res.data.noticeTitle
        dialogVisible.value = true
      }).finally(() => {
        loading.value = false
      })
    }
    
    const submitForm = () => {
      formRef.value?.validate((valid: boolean) => {
        if (valid) {
          submitLoading.value = true
          
          //发布公告
          if (noticeId.value == 0) {
            publicNotice('/pc/publish/publishNotice', form.value).then(res => {
              ElMessage.success('公告发布成功')
              dialogVisible.value = false
              pageContentRef.value.getPageData()
            }).finally(() => {
              submitLoading.value = false
            })
          } else { //编辑公告
            editNotice('/pc/publish/editNotice', {
              ...form.value,
              noticeId: noticeId.value,
              status: '0'
            }).then(res => {
              ElMessage.success('公告更新成功')
              dialogVisible.value = false
              pageContentRef.value.getPageData()
            }).finally(() => {
              submitLoading.value = false
            })
          }
        }
      })
    }
    
    return {
      pageContentRef,
      formRef,
      contentTableConfig,
      handleQueryClick,
      getNoticeContent,
      dialogVisible,
      loading,
      submitLoading,
      submitForm,
      changeEditor,
      addNotice,
      form,
      rules
    }
  }
})
